import {z} from "zod"

export const schema = z.object({
    name: z.string().min(1,'必須項目です').max(48,"48文字以内でご入力ください"),
    company: z.string().max(48,"48文字以内でご入力ください"),
    email: z.string().min(1,'必須項目です').max(255, { message: "255文字以内で入力してください" }).email('正しいメールアドレス入力してください'),
    tel: z.string({ required_error: "入力が必須の項目です" }).min(9,"電話番号は9文字以上で入力してください").max(11,"電話番号が長すぎます"),
    inquiry: z.string().min(1,'必須項目です').max(100,'100文字以内でご入力ください')
})

export type formInputs = z.infer<typeof schema>

